"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FaceOkOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FaceOkOutlineSVG = function FaceOkOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M16 2A14 14 0 112 16 14 14 0 0116 2zm0 2a12 12 0 1012 12A12 12 0 0016 4zm4.5 15.5a1 1 0 01.1 2H11a1 1 0 01-.1-2h9.6zM12 11a2 2 0 11-2 2 2 2 0 012-2zm8 0a2 2 0 11-2 2 2 2 0 012-2z"
  }));
};
exports.FaceOkOutlineSVG = FaceOkOutlineSVG;
FaceOkOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FaceOkOutlineSVG);
exports.default = _default;